export const checkIsSecuritySupported = () => {
  return (
    typeof CSS !== 'undefined' &&
    (CSS?.supports('text-security: disc') || CSS?.supports('-webkit-text-security: disc'))
  );
};
